import { defineCapability } from './internal';
import { args } from '../common/args';
export const UPSERT_GLOBAL_STYLES_CAP = defineCapability({
  name: 'UPSERT_GLOBAL_STYLES_CAP',
  args: {
    selector: args.string(),
    style: args.cssProperties(),
    persist: args.optional(args.object({
      id: args.string(),
      mode: args.or(args.literal('session'), args.literal('indefinite'))
    }))
  }
});